module.exports = __webpack_public_path__ + "img/icons BFr_12.789ff1f6.png";